export function isPreprod(): boolean {
  return (
    window.location.host.includes("preprod") ||
    window.location.host.includes("develop")
  );
}

export function getBFF(): string {
  return isPreprod()
    ? import.meta.env.VITE_APP_PREPROD_BFF
    : import.meta.env.VITE_APP_BFF;
}
